import Tool, { type ToolArgs } from '../../../tools/Tool';
import { inListOfType } from '../utils';
import ListWrapUtils from '../ListWrapUtils';

// Convert selection to/from a bulleted list.
class ToolBulletedList extends Tool {
  static toolName = 'Bulleted list';
  static iconClass = 'fa-regular fa-list-ul';

  static action({ editor }: ToolArgs): void {
    if (this.isActive({ editor })) {
      ListWrapUtils.unwrapList(editor);
    } else {
      ListWrapUtils.wrapInList(editor, { type: 'ul_list' });
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    return inListOfType(editor, 'ul_list');
  }

  static isEnabled({ controller }: ToolArgs): boolean {
    const tableSelection = controller?.state.pluginState.tableSelection;
    if (!tableSelection) return true;

    return !tableSelection.multipleCellsSelected;
  }
}

export default ToolBulletedList;
